import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/fun-products';
import '@grandvisionhq/lib-visuals';
import '@swc/helpers';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/inventory';
import '@grandvisionhq/utils';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-monetate';
import '@grandvisionhq/reviews';
import { PackageQuantityDropdownContainer } from '../../../../../Components/PackageQuantityDropdown/PackageQuantityDropdownContainer.js';
import { ProductDetailUnitInfo } from '../ProductDetailUnitInfo/ProductDetailUnitInfo.js';
import { joinExistingStrings } from './helpers/join-existing-strings.js';
import PackageQuantity from './PackageQuantity.js';
import { PriceAside } from './PriceAside.js';
import { usePackageQuantity } from './usePackageQuantity.js';

const PackageQuantityContainer = ({ onChange , packageTypes , selectedSize  })=>{
    const { getLabel  } = useIntl();
    const mapper = (pack, labels, currency)=>{
        var ref;
        const price = pack.price;
        const value = pack.packageQuantity.toString();
        var _perBoxLabel, _perEye;
        return {
            label: `${value} ${labels.lenses}`,
            value,
            subtext: joinExistingStrings([
                (_perBoxLabel = labels.perBoxLabel) !== null && _perBoxLabel !== void 0 ? _perBoxLabel : '',
                (_perEye = labels.perEye) !== null && _perEye !== void 0 ? _perEye : ''
            ], ', '),
            aside: /*#__PURE__*/ React.createElement(PriceAside, {
                value: price.value.centAmount,
                currency: currency,
                discountValue: price === null || price === void 0 ? void 0 : (ref = price.discounted) === null || ref === void 0 ? void 0 : ref.value.centAmount,
                asideLabel: labels.perEye
            })
        };
    };
    const packageQuantityLabel = getLabel('products.contactLenses.boxQuantity');
    const { labels: labels1 , packageQuantities  } = usePackageQuantity(packageTypes, mapper);
    if (!packageQuantities.length) {
        return null;
    }
    var _lens, _lenses;
    return /*#__PURE__*/ React.createElement(PackageQuantity, {
        packageQuantities: packageQuantities,
        item: /*#__PURE__*/ React.createElement(ProductDetailUnitInfo, {
            amount: +packageQuantities[0].value,
            valueUnits: {
                singular: (_lens = labels1.lens) !== null && _lens !== void 0 ? _lens : '',
                plural: (_lenses = labels1.lenses) !== null && _lenses !== void 0 ? _lenses : ''
            },
            perBox: packageQuantities[0].subtext
        }),
        dropdown: /*#__PURE__*/ React.createElement(PackageQuantityDropdownContainer, {
            label: packageQuantityLabel,
            items: packageQuantities,
            selectedSize: selectedSize,
            onChange: onChange
        })
    });
};

export { PackageQuantityContainer as default };
//# sourceMappingURL=PackageQuantityContainer.js.map
